var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.262.108c.423-.013.773.326.773.75v1.946c1.332.153 2.379 1.245 2.46 2.598l.005.17v8.57c0 1.482-1.157 2.694-2.616 2.781l-.17.006H3.286c-1.482 0-2.693-1.157-2.78-2.616l-.006-.17V5.57c0-1.43 1.077-2.608 2.465-2.767V.857c0-.42.345-.758.765-.749C6.201.16 8.64.728 11 1.785l-.317.145C13.096.802 15.639.191 18.262.108zM2 5.571v8.572c0 .71.576 1.286 1.286 1.286l5.646-.002c-1.72-.574-3.47-.884-5.234-.921-.407-.01-.733-.342-.733-.75v-9.43C2.41 4.47 2 4.972 2 5.571zm17.035-1.245v9.43c0 .408-.326.74-.733.75-1.764.037-3.515.347-5.234.921l5.646.002c.71 0 1.286-.576 1.286-1.286V5.57c0-.599-.41-1.102-.965-1.245zm-1.499-2.679c-1.99.15-3.927.633-5.787 1.445v11.216c1.892-.723 3.829-1.152 5.787-1.27V1.647zM4.464 1.64v11.397c1.958.12 3.895.548 5.787 1.271V3.092c-1.892-.83-3.829-1.318-5.787-1.452z",
    transform: "translate(-280 -330) translate(40 330) translate(240) translate(1 3)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.22909a1f.svg";
export { ForwardRef as ReactComponent };